<template>
  <div class="auth-layout row align-content--center">
    <!-- TODO reactive sync to vuex -->

    <div class="flex xs12 flex-center">
      <div class="flex-center">
        <h1 class="logo-size">SMART</h1>
      </div>
    </div>
    <va-notification color="danger" closeable v-if="false">
      <va-badge color="danger">Error</va-badge>Unauthorized
    </va-notification>
    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <div class="pa-3">
            <router-view />
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',

  data () {
    return {
      selectedTabIndex: 0,
    }
  },
  computed: {},
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  // background-image: linear-gradient(to right, #0e4ac4, #002c85);

  &__card {
    width: 100%;
    max-width: 600px;
  }
}
.logo-size {
  font-size: 10rem;
}
</style>
